module.exports = __webpack_public_path__ + "static/media/UYI.d0abf516.svg";